module.exports = __webpack_public_path__ + "static/logo-8dd665656567628d0a471f07f1c5ec46.png";